var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#link_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9.172 6.343 2.12-2.121a6 6 0 0 1 8.486 8.485l-2.121 2.121M14.828 17.657l-2.12 2.121a6 6 0 0 1-8.486-8.485l2.121-2.121M15.536 8.464l-7.072 7.072"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "link_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
SvgLink.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export default ForwardRef;